import ApiClient from '@afosto/api/ApiClient';

class Handling {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Create handling list
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Add a new handling list
   * @returns {Promise}
   */
  createHandlingList(body, options = {}) {
    return this.apiClient.request({
      url: `/lcs/lists`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Delete a handling list
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Delete a handling list
   * @returns {Promise}
   */
  deleteHandlingList(id, options = {}) {
    return this.apiClient.request({
      url: `/lcs/lists/${id}`,
      method: 'delete',
      ...options,
    });
  }

  /**
   * Get list of handling lists
   *
   * @param {Object} options - The additional request options
   * @description Returns a list of handling lists
   * @returns {Promise}
   */
  listHandlingLists(options = {}) {
    return this.apiClient.request({
      url: `/lcs/lists`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Search a set of lists
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Search for a set of lists
   * @returns {Promise}
   */
  searchLists(body, options = {}) {
    return this.apiClient.request({
      url: `/lcs/lists/search`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Update a handling list&#39;s items
   *
   * @param {string} id
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Update items&#39; state on a handling list
   * @returns {Promise}
   */
  updateHandlingListItem(id, body, options = {}) {
    return this.apiClient.request({
      url: `/lcs/lists/${id}/items`,
      method: 'put',
      data: body,
      ...options,
    });
  }

  /**
   * Update a handling list state
   *
   * @param {string} id
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Update state of an handling list
   * @returns {Promise}
   */
  updateListState(id, body, options = {}) {
    return this.apiClient.request({
      url: `/lcs/lists/${id}/state`,
      method: 'put',
      data: body,
      ...options,
    });
  }

  /**
   * View a handling list
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Returns a handling list
   * @returns {Promise}
   */
  viewHandlingList(id, options = {}) {
    return this.apiClient.request({
      url: `/lcs/lists/${id}`,
      method: 'get',
      ...options,
    });
  }
}

export const handling = new Handling();

export default Handling;
